import sdl from '@jds/react-generated-sdl/JDSDropdownMenu';
import type { JDSDropdownMenuProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, DropdownMenuProps } from '../logic';

const Component = (props: DropdownMenuProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    kind = 'single-select',
    searchTrigger = false,
    showCTAButtons = true,
    labelTextWrap = false,
    open = false,
    width = 'max-content',
    position = 'bottom_start',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    {
      kind,
      searchTrigger,
      showCTAButtons,
      labelTextWrap,
      open,
      width,
      position,
      ...rest
    },
    'JDSDropdownMenu',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const DropdownMenu = withLogic(Component) as React.FC<DropdownMenuProps> & {
  slotName?: string;
};

DropdownMenu.displayName = 'DropdownMenu';
DropdownMenu.slotName = 'jds_dropdown_menu';

export { DropdownMenu, type JDSDropdownMenuProps };
